import React, { useLayoutEffect } from 'react';
import { AppTab } from './appLayoutConfig';
import { ReactComponent as CompaniesIcon } from '../../../icons/crm-companies.svg';
import { ReactComponent as ProspectsIcon } from '../../../icons/crm-prospects.svg';
// import { ReactComponent as FunnelsIcon } from '../../../icons/crm-funnels.svg'; // Hidden for now
import { CompaniesGrid, ProspectsGrid } from './dsl-components';
import './sales-manager-crm-wrapper.scss';

interface SalesManagerCRMWrapperProps {
  threadId?: string;
  tabId: string;
  updateThreadViewVisualDescription?: (
    visualDescription: string,
  ) => Promise<void>;
  onTabsReady?: (tabs: AppTab[]) => void;
}

const SALES_MANAGER_CRM_TABS: AppTab[] = [
  { id: 'companies', label: 'Companies' },
  { id: 'prospects', label: 'Prospects' },
  // { id: 'funnels', label: 'Funnels' }, // Hidden for now - not ready for ship
];

const SalesManagerCRMWrapper: React.FC<SalesManagerCRMWrapperProps> = ({
  threadId,
  tabId,
  updateThreadViewVisualDescription,
  onTabsReady,
}) => {
  // Notify parent about available tabs synchronously
  useLayoutEffect(() => {
    if (onTabsReady) {
      onTabsReady(SALES_MANAGER_CRM_TABS);
    }
  }, [onTabsReady]);

  // Render the appropriate component based on selected tab
  const renderTabContent = () => {
    switch (tabId) {
      case 'companies':
        return (
          <CompaniesGrid
            threadId={threadId}
            updateThreadViewVisualDescription={
              updateThreadViewVisualDescription
            }
          />
        );
      case 'prospects':
        return (
          <ProspectsGrid
            threadId={threadId}
            updateThreadViewVisualDescription={
              updateThreadViewVisualDescription
            }
          />
        );
      case 'funnels':
        // Placeholder for Funnels - to be implemented
        return (
          <div className='funnels-placeholder'>Funnels coming soon...</div>
        );
      default:
        return (
          <CompaniesGrid
            threadId={threadId}
            updateThreadViewVisualDescription={
              updateThreadViewVisualDescription
            }
          />
        );
    }
  };

  return <div className='sales-manager-crm'>{renderTabContent()}</div>;
};

export default SalesManagerCRMWrapper;
